import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

import { ReactComponent as Tick } from "@assets/icons/inbox/tick.svg";

import { SvgIcon } from "../Icon/SvgIcon";

import type { AutoCompleteItem } from "./Dropdown";

interface DropdownOptionProps {
	item: AutoCompleteItem;
	/** Whether to show the tick: the item is the current selection and the menu shows ticks. */
	ticked: boolean;
	onSelect: (item: AutoCompleteItem) => void;
}

/**
 * One row of the Dropdown menu: the item's group heading when it starts a group (plain text, not a
 * button, so it is neither selectable nor counted as an option), then the selectable option.
 */
export const DropdownOption: FunctionComponent<DropdownOptionProps> = ({
	item,
	ticked,
	onSelect,
}) => (
	<>
		{item.groupHeading && (
			<div className="px-3 pt-2.5 pb-1 text-xs font-semibold text-text-meta" role="presentation">
				{item.groupHeading}
			</div>
		)}
		<button
			className={classNames(
				"flex flex-row justify-between items-center py-2.5 px-3 text-sm text-left text-gray-900 w-full bg-white hover:bg-gray-100 duration-200 cursor-pointer relative"
			)}
			type="button"
			onClick={(e) => {
				e.stopPropagation();
				onSelect(item);
			}}
		>
			<div className="flex flex-row items-center gap-2">
				{item.icon && <span className="flex items-center">{item.icon}</span>}
				{item.title}
			</div>
			{ticked && (
				<SvgIcon
					className="w-[20px] h-[20px] text-brand-light pointer-events-none"
					svgIcon={Tick}
				/>
			)}
		</button>
	</>
);
